



































import {Component, Prop, Provide, Vue} from 'vue-property-decorator'
import {NntTag} from '@/model/resource/NntTag'
import {InputNntTagSchema} from '@/schema/resource/NntTag/InputNntTagSchema'

@Component
export default class PersistNntTagView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputNntTagSchema()
  nntTag = new NntTag()

  async created() {
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.nntTag.getNntTag(id)
    }

    this.$await.done('getNntTag')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      this.$toast.abort('system.error.validation')
    }

    await this.nntTag.persistNntTag()
    this.$toast.success('system.success.persist')
    await this.$nav.push('/nnt-tag/list')
  }
}
